import { FC } from "react";
import { Text } from "@chakra-ui/react";
import { errorColor, successColor } from "../../../utils/colors";

interface IndicatorVariationStateColorProps {
  state?: number;
  variation?: number;
}

const IndicatorVariationStateColor: FC<IndicatorVariationStateColorProps> = ({
  state,
  variation,
}) => {
  let color: string;

  switch (state) {
    case 1:
      color = successColor;
      break;
    case 2:
      color = errorColor;
      break;
    case 3:
      color = "black";
      break;
    default:
      color = "black";
      break;
  }

  return (
    <Text
      px="1"
      textTransform="uppercase"
      fontSize="sm"
      color={color}
      fontWeight="bold"
    >
      {variation && typeof variation === "number"
        ? `${variation.toFixed(1)}%`
        : "-"}
    </Text>
  );
};

export default IndicatorVariationStateColor;
